import { Button, Checkbox, Col, Collapse, DatePicker, Divider, Empty, Form, Image, Input, message, Row, Select, Space, Spin, theme, Typography, Upload } from 'antd'
import React, { useEffect, useMemo, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import dayjs from 'dayjs'
import { changeModel, masterDataAddDropDown, masterDataDropDownList, profileState } from '../../profile/profile.slice'
import { debounce } from 'lodash'
import { MASTER_DATA_FIELD } from '../../../constants/masterData'
import { CompanyDefaultIcon, ExpandIcon, SkillsIcon, ToolsIcon } from '../../../assets/icons'
import DropDownMultiple from '../../../components/dropDownMultiple'
import { loginState } from '../../login/login.slice'
import ApiSelect from '../../../components/api-select/api-select'
import { candidateById, candidateEdit } from '../store/candidate.slice'


const ExperienceForm = ({ onCancel, currantData, activeTab, candidateId, preExperinceData }) => {

    const [form] = Form.useForm()

    const { Text, Title } = Typography

    const { TextArea } = Input


    const { useToken } = theme
    const { token } = useToken()
    const dispatch = useDispatch()

    const {
        formButtonType,
        modelType,
        masterDataDropDown,
        isNext
    } = useSelector(profileState)
    const { userProfile } = useSelector(loginState)

    const formatDatePicker = (value) => {
        return `${dayjs(value).format('DD MMM YY')}`
    }
    const [skillsData, setSkillsData] = useState([])
    const [toolsData, setToolsData] = useState([])
    const [checked, setChecked] = useState(false)
    const [suggestions, setSuggestions] = useState([])
    const [searchValue, setSearchValue] = useState('')
    const [page, setPage] = useState(0);
    const [status, setStatus] = useState("loading");
    const timeoutRef = useRef()

    const sessionTokenRef = useRef()


    const initialValues = useMemo(() => {

        return {
            title: currantData?.title ? currantData?.title : [],
            employmentType: currantData?.employmentType ? {
                label: currantData?.employmentType?.name,
                value: currantData?.employmentType?._id,
            } : null,
            company: currantData?.company ? {
                label: currantData?.company?.name,
                value: currantData?.company?._id,
            } : null,
            skills: currantData?.skills?.map((skill) => ({
                label: skill?.name,
                value: skill?._id,
            })) || [],
            summary: currantData?.summary || null,
            location: currantData?.location || null,
            startDate: currantData?.startDate ? dayjs(currantData.startDate) : "",
            endDate: currantData?.endDate ? dayjs(currantData.endDate) : "",
            softSkills: currantData?.skills || [],
            programmingLanguages: currantData?.programmingLanguages || [],
            tools: currantData?.tools?.length > 0
                ? currantData?.tools.map((data) => {
                    return {
                        label: data?.name,
                        value: data?._id,
                        logo: data?.logo,
                    }
                })
                : [],
            technicalSkills: currantData?.technicalSkills || [],
            currentlyWorking: currantData?.currentlyWorking || false
        }


    }, [currantData])

    useEffect(() => {
        if (currantData?.currentlyWorking) {

            setChecked(currantData?.currentlyWorking)
        }
    }, [currantData])


    // ADD MASTER DATA
    async function addMasterData() {
        const result = await dispatch(
            masterDataAddDropDown({
                addData: {
                    type: 'manual',
                    data: {
                        name: searchValue,
                        logo:
                            modelType === 'company'
                                ? 'https://pms-bucket123.s3.amazonaws.com/Page 1_1689584485.svg'
                                : '',
                        createdBy: userProfile?._id,
                    },
                },
                model: modelType,
            })
        )
        const data = result?.payload?.data

        if (data) {
            const { success, message: errorMessage } = data
            if (success) {
                dispatch(
                    masterDataDropDownList({
                        search: searchValue,
                        id: modelType,
                        // limit: pageLimit,
                        // skip: skipPage,
                    })
                )
            } else {
                if (errorMessage) {
                    message.error(errorMessage)
                } else {
                    message.error('Something went wrong, try again later.')
                }
            }
        }
    }

    const fetchOptions = async (search = "", pageNumber = 1, model) => {
        setStatus("loading");
        setSearchValue(search);

        try {
            dispatch(changeModel(model))
            const result = await dispatch(
                masterDataDropDownList({
                    search: search,
                    id: model,
                    skip: pageNumber
                })
            ).unwrap(); // ⬅️ Get the actual payload

            const newData = Array.isArray(result?.data) ? result.data : [];


            setPage(pageNumber + 1);
            setStatus(newData.length === 0 ? "noData" : "loaded");
        } catch (error) {
            console.error("Dropdown fetch failed", error);
            setStatus("noData");
        }
    };


    const resetPage = () => {
        setPage(1);
    };

    // GOOGLE PLACE API INTEGRATION
    const loadSuggestions = async (inputValue) => {
        clearTimeout(timeoutRef.current)

        if (!inputValue || inputValue.trim().length <= 1) {
            setSuggestions([])
            return
        }

        timeoutRef.current = setTimeout(async () => {
            if (!sessionTokenRef.current) {
                sessionTokenRef.current =
                    new window.google.maps.places.AutocompleteSessionToken()
            }

            new window.google.maps.places.AutocompleteService().getPlacePredictions(
                {
                    input: inputValue,
                    sessionToken: sessionTokenRef.current,
                },
                (predictions, status) => {
                    if (
                        status ===
                        window.google.maps.places.PlacesServiceStatus
                            .ZERO_RESULTS
                    ) {
                        setSuggestions([])
                        return
                    }
                    if (
                        status !==
                        window.google.maps.places.PlacesServiceStatus.OK ||
                        !predictions
                    ) {
                        return
                    }
                    let newData =
                        predictions?.length > 0 &&
                        predictions.map((data) => {
                            return {
                                label: data?.description,
                                value: data?.description,
                            }
                        })
                    setSuggestions(newData)
                }
            )
        }, 350)
    }


    // DISABLE START DATE
    const disabledDateStart = (current) => {
        const endDate = form.getFieldValue('endDate')
        // Disable dates that are after the selected end date or dates that are in the future
        return (
            (endDate && current && current.valueOf() > endDate.valueOf()) ||
            (current && current.valueOf() > Date.now())
        )
    }
    // DISABLE END DATE

    const disabledDateEnd = (current) => {
        const startDate = form.getFieldValue('startDate')
        // Disable dates that are before the selected start date or dates that are in the past
        return startDate
            ? (current && current.valueOf() < startDate.valueOf()) ||
            (current && current.valueOf() > Date.now())
            : current && current.valueOf() > Date.now()
    }

    // COLLAPSE MENU HEADER
    const CollapseLabel = ({ name, icon, description }) => (
        <Row
            align={'middle'}
            style={{
                columnGap: '20px',
                marginBottom: '18px',
                rowGap: "10px"
            }}
        >
            <Row
                style={{
                    height: '50px',
                    width: '50px',
                    borderRadius: '10px',
                    padding: '12px',
                    backgroundColor: token.colorPalette.baseColor.tertiary,
                }}
                align={'middle'}
                justify={'center'}
            >
                <div
                    style={{
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: '30px',
                    }}
                >
                    {icon}
                </div>
            </Row>
            <div>
                <Title
                    style={{
                        // fontSize: token.fontSizeHeading4,
                        fontSize: '18px',
                    }}
                >
                    {name}
                </Title>
                <Text className="sub-title" style={{ fontSize: '15px' }}>
                    {description}
                </Text>
            </div>
        </Row>
    )



    // COLLAPSE ITEMS
    const getItems = () => [
        {
            key: '1',
            label: (
                <CollapseLabel
                    name={`Add Skills ${skillsData?.length > 0 ? `(${skillsData?.length})` : ''
                        }`}
                    icon={
                        <SkillsIcon
                            color={token.colorPalette.baseColor.white}
                        />
                    }
                    description="Please add the skills suitable to your expertise."
                />
            ),
            children: (
                <>

                    <ApiSelect
                        // label="Search Skills*"
                        name={MASTER_DATA_FIELD.skills}
                        rules={
                            formButtonType !== 'draftButtonLoading'
                                ? [{ required: true, message: 'Please Select Field of skills' }]
                                : []
                        }
                        placeholder="Search a Field of skills"
                        tagRender={() => null}
                        rootClassName={[
                            'p-0-multiSelect',
                            skillsData?.length > 0
                                ? 'p-0-multiselect-setMargin'
                                : '',
                        ]}
                        onClick={() => {
                            resetPage();
                            fetchOptions("", 0, MASTER_DATA_FIELD.skills);
                        }}
                        onSelect={(e, options) => {
                            const trimSkills = options?.key.trimStart()
                            if (trimSkills?.length > 0) {
                                setSkillsData([
                                    ...skillsData,
                                    { label: trimSkills, value: e },
                                ])
                            }
                        }}
                        onDeselect={(e) => {
                            const removeData = [...skillsData]
                            removeData.splice(
                                removeData.findIndex(
                                    (item) => item.label === e
                                ),
                                1
                            )
                            setSkillsData(removeData)
                        }}
                        mode={"multiple"}
                        onSearch={(value) => {
                            resetPage();
                            fetchOptions(value, 0, MASTER_DATA_FIELD.skills);
                        }}
                        onScrollBottom={() => {
                            fetchOptions(searchValue, page, MASTER_DATA_FIELD.skills);
                        }}
                        dropdownRender={(menu, handleScroll) => (
                            <DropDownMultiple
                                handleScroll={handleScroll}
                                menu={menu}
                                searchValue={searchValue}
                                name={
                                    MASTER_DATA_FIELD.skills
                                }
                                addMasterData={() =>
                                    addMasterData()
                                }
                            />
                        )}
                        options={masterDataDropDown?.skills}
                        dropdownStatus={status}
                    />

                </>
            ),
        },
        {
            key: '2',
            label: (
                <CollapseLabel
                    name={`Add Tools ${toolsData?.length > 0 ? `(${toolsData?.length})` : ''
                        }`}
                    icon={
                        <ToolsIcon color={token.colorPalette.baseColor.white} />
                    }
                    description="Please add tools suitable to your hands-on experience."
                />
            ),
            children: (
                <>

                    <ApiSelect
                        // label="Search Skills*"
                        name={MASTER_DATA_FIELD.tools}
                        rules={
                            formButtonType !== 'draftButtonLoading'
                                ? [{ required: true, message: 'Please Select Field of tools' }]
                                : []
                        }
                        placeholder="Search a Field of tools"
                        tagRender={() => null}
                        rootClassName={[
                            'p-0-multiSelect',
                            toolsData?.length > 0
                                ? 'p-0-multiselect-setMargin'
                                : '',
                        ]}
                        onClick={() => {
                            resetPage();
                            fetchOptions("", 0, MASTER_DATA_FIELD.tools);
                        }}
                        onSelect={(e, options) => {
                            const trimSkills = options?.key.trimStart()
                            if (trimSkills?.length > 0) {
                                setToolsData([
                                    ...toolsData,
                                    { label: trimSkills, value: e },
                                ])
                            }
                        }}
                        onDeselect={(e) => {
                            const removeData = [...toolsData]
                            removeData.splice(
                                removeData.findIndex(
                                    (item) => item.label === e
                                ),
                                1
                            )
                            setToolsData(removeData)
                        }}
                        mode={"multiple"}
                        onSearch={(value) => {
                            resetPage();
                            fetchOptions(value, 0, MASTER_DATA_FIELD.tools);
                        }}
                        onScrollBottom={() => {
                            fetchOptions(searchValue, page, MASTER_DATA_FIELD.tools);
                        }}
                        dropdownRender={(menu, handleScroll) => (
                            <DropDownMultiple
                                handleScroll={handleScroll}
                                menu={menu}
                                searchValue={searchValue}
                                name={
                                    MASTER_DATA_FIELD.tools
                                }
                                addMasterData={() =>
                                    addMasterData()
                                }
                            />
                        )}
                        options={masterDataDropDown?.tools}
                        dropdownStatus={status}
                    />

                </>
            ),
        },
    ]

    const handleCreateAndEditExperience = async (edit) => {
        try {

            const values = await form.validateFields();
            const extractValue = (input) => {
                if (Array.isArray(input)) {
                    return input.map(item => item?.value || item)
                } else if (input && typeof input === 'object') {
                    return input.value || input._id || input
                }
                return input
            }
            const newEducationEntry = {

                title: values?.title ? values?.title : null,
                employmentType: extractValue(values?.employmentType) || null,
                skills: extractValue(values.skills) || null,
                tools: extractValue(values.tools) || null,
                company: extractValue(values?.company) || null,
                location: values?.location || null,
                startDate: values.startDate?.valueOf() || "",
                endDate: values.endDate?.valueOf() || "",
                softSkills: extractValue(values?.skills) || [],
                programmingLanguages: extractValue(values?.programmingLanguages) || [],
                summary: values.summary,
                currentlyWorking: checked,
                isCompleted: true
            }

            let payload = {}

            if (edit) {
                // Only send edited entry
                const existingEducation = preExperinceData?.experience || []
                const filteredEducation = existingEducation.filter(
                    edu => edu._id !== currantData?._id
                );

                payload = {
                    experience: [...filteredEducation, newEducationEntry],
                    candidateId: candidateId
                }
            } else {
                // Append new entry to existing education array
                const existingEducation = preExperinceData?.experience || []
                payload = {
                    experience: [...existingEducation, newEducationEntry],
                    candidateId: candidateId
                }
            }

            const { data } = await candidateEdit(activeTab, candidateId, payload)
            if (data?.success) {
                dispatch(candidateById({ id: data?.data?._id, activeTab }))
                message.success(edit ? "Experience Update Success" : "Experience Create")
                onCancel(false)
            }
        } catch (error) {
            console.log("🚀 ~ handleCreateEducation ~ error:", error)
        }
    }



    return (
        <div>
            <Form
                layout="vertical"
                labelCol={{
                    style: {
                        padding: '0 0 3px',
                    },
                }}
                name="addExperience"
                // onFinish={onFinishExperience}
                // onFinishFailed={onFinishFailed}
                initialValues={initialValues}
                requiredMark={true}
                // onSubmitCapture={async (e) => {
                //     // if (e.nativeEvent.submitter.id === 'draftButtonLoading') {
                //     //     form.resetFields()
                //     // }
                //     await dispatch(checkButtonType(e.nativeEvent.submitter.id))
                // }}
                form={form}
                style={{
                    marginBottom: '20px',
                    overflowX: 'hidden',
                }}
            >
                <Row
                    style={{
                        rowGap: '20px',
                    }}
                    justify={'space-between'}
                    gutter={16}
                >
                    <Col span={12}>
                        <Form.Item
                            label="Title"
                            name="title"
                            rules={
                                formButtonType !== 'draftButtonLoading'
                                    ? [
                                        {
                                            required: true,
                                            message: 'Please Enter Title',
                                        },
                                        {
                                            max: 50,
                                            message:
                                                'Title should be maximum 50 characters long',
                                        },
                                    ]
                                    : []
                            }
                            colon={false}
                        >
                            <Input
                                name="title"
                                placeholder="Enter Title"
                                onChange={(e) => {
                                    form.setFieldValue(
                                        'title',
                                        e.target.value.trimStart()
                                    )
                                }}
                            />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <ApiSelect
                            label="Employment Type"
                            name={MASTER_DATA_FIELD.employmentType}
                            rules={
                                formButtonType !== 'draftButtonLoading'
                                    ? [{ required: true, message: 'Please Select Field of employmentType' }]
                                    : []
                            }
                            placeholder="Search a Field of employmentType"
                            onClick={() => {
                                resetPage();
                                fetchOptions("", 0, MASTER_DATA_FIELD.employmentType);
                            }}
                            onSearch={(value) => {
                                resetPage();
                                fetchOptions(value, 0, MASTER_DATA_FIELD.employmentType);
                            }}
                            onScrollBottom={() => {
                                fetchOptions(searchValue, page, MASTER_DATA_FIELD.employmentType);
                            }}
                            dropdownRender={(menu, handleScroll) => (
                                <DropDownMultiple
                                    handleScroll={handleScroll}
                                    menu={menu}
                                    searchValue={searchValue}
                                    name={
                                        MASTER_DATA_FIELD.employmentType
                                    }
                                    addMasterData={() =>
                                        addMasterData()
                                    }
                                />
                            )}
                            options={masterDataDropDown?.employmentType}
                            dropdownStatus={status}
                            isNext={isNext}
                        />
                    </Col>

                    <Col span={12}>
                        <ApiSelect
                            label="Company Name"
                            name={MASTER_DATA_FIELD.company}
                            rules={
                                formButtonType !== 'draftButtonLoading'
                                    ? [{ required: true, message: 'Please Select Field of company' }]
                                    : []
                            }
                            placeholder="Search a Field of company"
                            onClick={() => {
                                resetPage();
                                fetchOptions("", 0, MASTER_DATA_FIELD.company);
                            }}
                            onSearch={(value) => {
                                resetPage();
                                fetchOptions(value, 0, MASTER_DATA_FIELD.company);
                            }}
                            onScrollBottom={() => {
                                fetchOptions(searchValue, page, MASTER_DATA_FIELD.company);
                            }}
                            dropdownRender={(menu, handleScroll) => (
                                <DropDownMultiple
                                    handleScroll={handleScroll}
                                    menu={menu}
                                    searchValue={searchValue}
                                    name={
                                        MASTER_DATA_FIELD.company
                                    }
                                    addMasterData={() =>
                                        addMasterData()
                                    }
                                />
                            )}
                            options={masterDataDropDown?.company}
                            dropdownStatus={status}
                            isNext={isNext}
                        />
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            label="Location"
                            name="location"
                            rules={
                                formButtonType !== 'draftButtonLoading'
                                    ? [
                                        {
                                            required: true,
                                            message: 'Please Select Location',
                                        },
                                    ]
                                    : []
                            }
                            colon={false}
                        >
                            <Select
                                placeholder="Search a Location"
                                allowClear={false}
                                onSearch={(value) => {
                                    loadSuggestions(value)
                                }}
                                notFoundContent={
                                    <Empty
                                        image={Empty.PRESENTED_IMAGE_SIMPLE}
                                        description="No Locations Searched"
                                    ></Empty>
                                }
                                showSearch
                                options={suggestions}
                                getPopupContainer={(trigger) => trigger.parentNode}
                            />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            label="Start Date"
                            colon={false}
                            name={'startDate'}
                            rules={
                                formButtonType !== 'draftButtonLoading'
                                    ? [
                                        {
                                            required: true,
                                            message: 'Please Select Start Date',
                                        },
                                    ]
                                    : []
                            }
                        >
                            <DatePicker
                                allowClear={false}
                                name="startDate"
                                disabledDate={disabledDateStart}
                                format={formatDatePicker}
                                // getPopupContainer={(trigger) =>
                                //     trigger.parentNode
                                // }
                                getPopupContainer={() => document.body}
                            />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            label="End Date"
                            colon={false}
                            name={'endDate'}
                            rules={
                                formButtonType !== 'draftButtonLoading' && !checked
                                    ? [
                                        {
                                            required: true,
                                            message: 'Please Select End Date',
                                        },
                                    ]
                                    : []
                            }
                        >
                            <DatePicker
                                allowClear={false}
                                name="endDate"
                                disabled={checked}
                                disabledDate={disabledDateEnd}
                                format={formatDatePicker}
                                // getPopupContainer={(trigger) =>
                                //     trigger.parentNode
                                // }
                                getPopupContainer={() => document.body}
                            />
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item
                            label="Summary"
                            name="summary"
                            rules={
                                formButtonType !== 'draftButtonLoading'
                                    ? [
                                        {
                                            required: true,
                                            message: 'Please Enter Summary',
                                        },
                                        {
                                            min: 8,
                                            max: 250,
                                            message:
                                                'Summary is minimum 8 and maximum 250 characters long',
                                        },
                                    ]
                                    : []
                            }
                            colon={false}
                        >
                            <TextArea
                                rows={4}
                                placeholder={'Enter Summary...'}
                                name={'summary'}
                                onChange={(e) => {
                                    form.setFieldValue(
                                        'summary',
                                        e.target.value.trimStart()
                                    )
                                }}
                            />
                        </Form.Item>
                    </Col>
                    <Col>
                        <Form.Item name="currentlyWorking" valuePropName="checked">
                            <Checkbox
                                onChange={(e) => {
                                    const isChecked = e.target.checked
                                    setChecked(isChecked)
                                    if (isChecked) {
                                        // Clear errors only when the checkbox is checked
                                        form.setFields([
                                            {
                                                name: 'endDate',
                                                errors: [],
                                            },
                                        ])
                                    }

                                    // Optionally set the value of 'end' to an empty string or null
                                    form.setFieldValue('endDate', isChecked ? '' : null)
                                }}
                            >
                                I am currently working in this role
                            </Checkbox>
                        </Form.Item>
                    </Col>
                </Row>
                <Divider />
                <Collapse
                    bordered={false}
                    defaultActiveKey={['1', '2']}
                    expandIcon={({ isActive }) => {
                        return <ExpandIcon isActive={!isActive} />
                    }}
                    expandIconPosition="right"
                    style={{
                        backgroundColor: 'transparent',
                    }}
                    items={getItems()}
                />
                <Divider style={{ marginTop: '0px' }} />
                <div
                    style={{
                        marginTop: '15px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'end',
                    }}
                >

                    <Button
                        variant="outlined"

                        style={{ marginRight: "10px", color: "#000", backgroundColor: "transparent", border: "1px solid #d9d9d9" }}
                        color="default"
                        onClick={() => onCancel(false)}
                    >
                        Cancel
                    </Button>
                    <Button style={{ marginLeft: '12px' }} onClick={() => currantData ? handleCreateAndEditExperience("edit") : handleCreateAndEditExperience()}>{currantData ? "Save Change" : " Add"}</Button>
                </div>
            </Form>

        </div>
    )
}


export default ExperienceForm
